export enum IntegrationStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
}
